export default {
	president: 1,
	general_manager: 2,
	product_manager: 3,
	business_analyst: 4,
	internal_operations_lead: 5,
	people_operations_lead: 6,
	people_operations_officer: 7,
	software_engineering_lead: 8,
    software_engineer: 9,
    it_support_officer: 10,
    logistics_lead: 11,
    operation_lead: 12,
    store_supervisor: 14,
    collections_verification_lead: 16,
    dsa_captain: 17,
    dsa: 18,
    floor_sales_rep: 19,
    inventory_officer: 20,
    document_verify_agent: 21,
    document_verify_agent_captain: 22,
    collection_agent: 23,
    driver: 24,
    delivery_driver: 25,
    junior_acc: 26,
    buyer: 27,
    software_app_support: 28,
    internal_auditor: 30,
    admin_finance_officer: 31,
    coordinator: 32,
    altara_pay_agent: 33,
    credit_checker: 34,
    people_operation_admin_agent: 35,
    operation_manager: 36,
    people_excellence_manager: 37,
    performance_excellence_manager: 38,
    learn_dev_officer: 39,
    operations_audit_lead: 40,
    finance_manager: 41,
    cash_loan_agent: 42,
    renewal_agent: 43,
    dsa_referral: 44,
    dsa_renewal: 45,
    freelance_captain: 46,
    rent_agent: 47
};
